import { Tooltip } from '@mui/material';
import { StyledChip } from './SharedStyles';

export const ThresholdRangeDetail = ({
  minThreshold,
  maxThreshold,
}: {
  minThreshold: number;
  maxThreshold: number;
}) => {
  return (
    <Tooltip title={`Common geometry ${minThreshold}% - ${maxThreshold}%`}>
      <StyledChip label={`${minThreshold}% - ${maxThreshold}%`} size='small' color='default' />
    </Tooltip>
  );
};
